import _ from 'underscore';

import { call, put } from 'redux-saga/effects';
import { Messages } from '../../../../codegen/Localize';
import { Filter } from '../../../../ts/helpers/Filter';
import { SliceableHelper } from '../../../../ts/helpers/SliceableHelper';
import { IContentInfo } from '../../../../ts/models/IContentInfo';
import { IDataConnectionInfo } from '../../../../ts/models/IDataConnectionInfo';
import { DataConnections } from '~src/connectivity/resources/DataConnections';
import { EditConnectionDialog } from '../../../../connectivity/services/EditConnectionDialog';
import { requestFailed } from '../../../actions/RequestFailedAction';
import { EditConnectionAction } from '../../../actions/spaces/EditConnectionAction';
import { requestSpaceContents } from '../../../actions/spaces/RequestSpaceContentsActions';
import { replaceDatasourceIdWithConnectionIdForMixedContent } from '../SpacesSagaHelpers';

export function* handleEditDataConnectionAction(action: EditConnectionAction) {
  try {
    let mutatableContentCopy: IContentInfo[] = [];
    mutatableContentCopy = yield call(replaceDatasourceIdWithConnectionIdForMixedContent, action.dataConnectionsOrSources);

    //Partition the content infos into sets for dataSources and dataConnections.
    const groups = _.groupBy(mutatableContentCopy, item => item.contentType);
    const dataSourceArray: IContentInfo[] = groups['datasource'] || [];
    const dataConnectionArray: IContentInfo[] = groups['dataconnection'] || [];

    //A single DataSource can be expanded into one or many IDataConnectionInfo objects
    let dataSourceDetails: IDataConnectionInfo[] = [];
    if (dataSourceArray.length > 0) {
      dataSourceDetails = yield call(getDataConnectionInfos, dataSourceArray, 'datasourceId');
    }

    let dataConnectionDetails: IDataConnectionInfo[] = [];
    if (dataConnectionArray.length > 0) {
      dataConnectionDetails = yield call(getDataConnectionInfos, dataConnectionArray, 'id');
    }

    let combinedConnectionDetails: IDataConnectionInfo[] = dataSourceDetails.concat(dataConnectionDetails);
    yield call(openEditConnectionWindow, combinedConnectionDetails);
    yield put(requestSpaceContents());
  } catch (e) {
    yield put(requestFailed(e, Messages.errorUnknown()));
  }
}

export function openEditConnectionWindow(connections: IDataConnectionInfo[]) {
  return EditConnectionDialog.confirmEditConnections(connections);
}

export function getDataConnectionInfos(dataConnectionsOrSources: IContentInfo[], queryField: string): Promise<IDataConnectionInfo[]> {
  const connectionOrSourceIdArray = dataConnectionsOrSources.map(w => w.id);

  const makeQueryFromIdsBlock = (idsBlock: string[]) =>
      DataConnections.all().addFilter(Filter.stringFieldInArray(queryField, idsBlock));

  return SliceableHelper.fetchAllForSliceableWithArrayParam(
    connectionOrSourceIdArray,
    makeQueryFromIdsBlock
  );
}
